import type { ReactNode } from 'react'
import React, { useMemo, useState } from 'react'
import type { _StepperProgressState } from './_StepperProgressContext'
import _StepperProgressContext from './_StepperProgressContext'
import _StepsTrack from './_StepsTrack'

interface Props {
  /**
   * `<StepperProgressStep />`s as children.
   */
  children: ReactNode
  /**
   * Must be within the bounds of the rendered steps.
   *
   * _Starts at zero!_
   */
  activeStepIndex: number
}

/**
 * The overflowing steps will be masked,
 * and the currently active step is always scrolled horizontally centre.
 */
function StepperProgressSteps({ children, activeStepIndex }: Props) {
  // Why is this stateful? Why not just a ref?
  // Because we need to update the context value with the current element ref.
  const [trackElement, setTrackElement] = useState<HTMLDivElement | null>(null)
  const contextState = useMemo<_StepperProgressState>(() => ({
    activeStepIndex,
    trackElement,
  }), [activeStepIndex, trackElement])

  return <_StepsTrack ref={setTrackElement}>
    <_StepperProgressContext.Provider value={contextState}>
      {children}
    </_StepperProgressContext.Provider>
  </_StepsTrack>
}

export default StepperProgressSteps
